import { useTranslation } from 'react-i18next'
import { Loader2 } from "lucide-react"

interface InfiniteScrollLoaderProps {
  loading: boolean
  hasMore: boolean
  ref?: React.RefObject<HTMLDivElement>
}

export function InfiniteScrollLoader({ loading, hasMore, ref }: InfiniteScrollLoaderProps) {
  const { t } = useTranslation()
  if (!hasMore) return null

  return (
    <div 
      ref={ref}
      className="flex items-center justify-center py-4"
    >
      {loading && (
        <div className="flex items-center gap-2 text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="text-sm">{t('functions.loading_more_conversations')}</span>
        </div>
      )}
    </div>
  )
}